export default Object.freeze({
  ACTIVE: 'ACTIVE',
  UPCOMING: 'UPCOMING',
  PAST: 'PAST',
})
